export default {
  walletNotifications(state) {
    if (
      state.walletSummary.wallet &&
      state.walletSummary.wallet.settings &&
      state.walletSummary.wallet.settings.notifications
    )
      return state.walletSummary.wallet.settings.notifications
    return {}
  },
  walletSurveys(state) {
    if (
      state.walletSummary.wallet &&
      state.walletSummary.wallet.settings &&
      state.walletSummary.wallet.settings.surveys
    )
      return state.walletSummary.wallet.settings.surveys
    return {}
  },

  getWalletDetails(state) {
    return state.walletDetails
  },
}
